import { injectable } from 'inversify-props';
import BaseService from '@/services/base-service';
import ClonedUploadModel from '@/models/crm/cloned-upload.model';

@injectable()
export default class UploadService extends BaseService {
  delete(filePath: string): Promise<void> {
    return this.httpService.delete(`${this.getApiPath()}/crm/upload?filePath=${filePath}`);
  }

  async clone(
    targetFilePath: string,
    filename: string,
    clientId: string,
    place: string,
    hash: string,
  ): Promise<ClonedUploadModel> {
    return (await this.httpService.post(ClonedUploadModel, `${this.getApiPath()}/crm/upload/clone`, {
      targetFilePath,
      filename,
      clientId,
      place,
      hash,
    })) as ClonedUploadModel;
  }

  getUploadUrl(): string {
    return `${this.getApiPath()}/crm/upload`;
  }

  getDownloadUrl(path: string): string {
    return `${this.getApiPath()}/crm/upload/download${path}`;
  }
}
